import type { IWhereUsedSectionTab } from '~/components/pages/directions/where-used-section/where-used-section.types'

const WHERE_USED_CONFERENCE_SYSTEM: IWhereUsedSectionTab[] = [
    {
        title: 'Конференции',
        image: '/assets/images/usage/conference-system/jpg-png/commission.png',
        image_webp:
            '/assets/images/usage/conference-system/webp/commission.webp',
        text: `
                <p>Чаще всего микрофонные пульты конференц-системы ставят в&nbsp;президиум. Высокочувствительные конденсаторные микрофоны обеспечивают великолепную разборчивость речи выступающих. А&nbsp;стильный деловой дизайн пультов хорошо смотрится на&nbsp;столах и&nbsp;в&nbsp;объективах камер.</p>
            `,
    },
    {
        title: 'Переговоры',
        image: '/assets/images/usage/conference-system/jpg-png/speech.png',
        image_webp: '/assets/images/usage/conference-system/webp/speech.webp',
        text: `
                <p>Благодаря наличию у&nbsp;председательского пульта кнопки отключения всех активных микрофонов, можно вовремя остановить разразившуюся перепалку при эмоциональных переговорах.</p>
                <p>Такой способ модерации позволит сохранить нормальную рабочую обстановку и&nbsp;регулировать порядок диалогов.</p>
            `,
    },
    {
        title: 'Лекции',
        image: '/assets/images/usage/conference-system/jpg-png/performance.png',
        image_webp:
            '/assets/images/usage/conference-system/webp/performance.webp',
        text: `
                <p>Высокочувствительный конденсаторный капсюль микрофона передаст все нюансы речи докладчика.</p>
                <p>Достаточно поставить один микрофон на&nbsp;трибуну лектора и&nbsp;выступление пройдет с&nbsp;высоким качеством звука. А&nbsp;гибкая ножка микрофона позволит настроить нужную высоту и&nbsp;позицию микрофона для каждого индивидуально.</p>
            `,
    },
    {
        title: 'Круглый стол',
        image: '/assets/images/usage/conference-system/jpg-png/state-duma.png',
        image_webp:
            '/assets/images/usage/conference-system/webp/state-duma.webp',
        text: `
                <p>При рассадке участников мероприятия по&nbsp;кругу важным нюансом является сокращение кабельной коммутации от&nbsp;микрофонов, которых в&nbsp;данном случае будет сосредоточено в&nbsp;одной зоне очень много. Для решения этой задачи и&nbsp;используется конференц-система, поскольку пульты подключаются последовательно цепочкой друг за&nbsp;другом и&nbsp;только от&nbsp;последнего микрофона один кабель прокладывается до&nbsp;центрального блока управления.</p>
            `,
    },
]

export default WHERE_USED_CONFERENCE_SYSTEM
